import apiClient from "./apiClient";

export const housekeepingCommissionRepository = {
  getAll: async () => {
    return await apiClient.get("/housekeeping-commissions");
  },

  getById: async (uuid) => {
    return await apiClient.get(`/housekeeping-commissions/${uuid}`);
  },

  store: async (data) => {
    return await apiClient.post("/housekeeping-commissions", data);
  },

  update: async (data, uuid) => {
    return await apiClient.put(`/housekeeping-commissions/${uuid}`, data);
  },

  delete: async (uuid) => {
    return await apiClient.delete(`/housekeeping-commissions/${uuid}`);
  },

  search: async (keyword) => {
    return await apiClient.get(`/housekeeping-commissions/search?keyword=${keyword}`);
  },
};
